/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import send from '../../utils/fetch'

export default {
  async ADVERTISER_TEST({commit}, id) {
    try {
      const response = send(`${global.$url.advrtsr.test}?id=${id}`, 'POST')
      return response
    } catch (e) {
    }
  }
}
